import {
    Directive,
    ElementRef,
    Output,
    EventEmitter,
    NgZone,
    HostListener
} from '@angular/core';

@Directive({
    selector: '[appPlaceAutocomplete]'
})
export class PlaceAutocompleteDirective {
    @Output() suggestionsChanged = new EventEmitter<any[]>();
    @Output() placeSelected = new EventEmitter<any>();

    private sessionToken: any;
    private fetchAutocompleteSuggestions: any;

    constructor(private elRef: ElementRef<HTMLInputElement>, private ngZone: NgZone) {
        this.initGoogle();
    }

    private async initGoogle() {
        const { AutocompleteSessionToken, AutocompleteSuggestion }: any =
            await google.maps.importLibrary('places');

        this.sessionToken = new AutocompleteSessionToken();
        this.fetchAutocompleteSuggestions = AutocompleteSuggestion.fetchAutocompleteSuggestions;
    }

    @HostListener('input', ['$event'])
    async onInput(event: Event) {
        const input = (event.target as HTMLInputElement).value;
        if (!input || !this.fetchAutocompleteSuggestions) return;

        const request = {
            input,
            sessionToken: this.sessionToken,
            region: 'us',
            language: 'en-US'
        };

        try {
            const { suggestions } = await this.fetchAutocompleteSuggestions(request);
            this.ngZone.run(() => {
                this.suggestionsChanged.emit(suggestions);
            });
        } catch (error) {
            console.error('Autocomplete error:', error);
        }
    }

    async selectSuggestion(suggestion: any) {
        try {
            const place = suggestion.placePrediction.toPlace();
            await place.fetchFields({
                fields: ['displayName', 'formattedAddress', 'location', 'addressComponents']
            });
            this.ngZone.run(() => {
                this.placeSelected.emit(place.toJSON());
            });
        } catch (err) {
            console.error('Error fetching place details:', err);
        }
    }
}
